module.exports = __webpack_public_path__ + "img/like.c59d59a7.svg";